<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <i class="fa fa-list"></i> Tipos de Comprobantes
        <router-link
          class="pull-right btn btn-sm btn-success text-white"
          to="/cuentas-cks/crear"
        >
          <i class="fa fa-plus" /> Nuevo
        </router-link>
      </div>
      <b-row>
        <b-col cols="12">
          <b-table
            hover
            small
            show-empty
            empty-text="No hay registros para mostrar"
            responsive="sm"
            :items="items"
            :fields="fields"
            :per-page="perPage"
            :busy="isLoading"
          >
            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>&nbsp; &nbsp;Cargando...</strong>
              </div>
            </template>
            <template slot="top-row">
              <td>
                <input
                  type="text"
                  v-model="cuenta"
                  class="form-control"
                  v-on:keyup.enter="getRegistros()"
                />
              </td>
              <td>
                <b-form-select
                  v-model="formato"
                  :options="formatos"
                  @input="getRegistros()"
                ></b-form-select>
              </td>
              <td>
                <b-form-select
                  v-model="empresa_id"
                  :options="empresas"
                  value-field="id"
                  text-field="nombre"
                  @input="getRegistros()"
                ></b-form-select>
              </td>
              <td>
                <b-form-select
                  v-model="activa"
                  :options="sino"
                  @input="getRegistros()"
                ></b-form-select>
              </td>

              <td></td>
            </template>
            <template v-slot:cell(actions)="row">
              <router-link
                class="enlace"
                v-b-tooltip.hover
                title="Editar"
                :to="'/cuentas-cks/' + row.item.id"
                ><i class="fa fa-pencil"
              /></router-link>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="mt-4"
            @input="getRegistros"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "cuentascks",
  data: () => {
    return {
      empresas: [],
      empresa_id: undefined,
      cuenta: undefined,
      formato: undefined,
      centro: undefined,
      centros: [],
      activa: 1,
      perPage: 15,
      currentPage: 1,
      totalRows: 0,
      isLoading: true,
      items: [],
      sino: [{ value: 1, text: "Si" }, { value: 0, text: "No" }],
      formatos: [
        { value: 1, text: "Pre impreso" },
        { value: 2, text: "Normal" }
      ],
      fields: [
        {
          label: "Cuenta",
          key: "cuenta",
          sortable: true
        },
        {
          key: "formato_valor",
          sortable: true,
          class: "text-center",
          label: "Formato"
        },
        {
          key: "empresa",
          sortable: true,
          class: "text-center",
          label: "Empresa"
        },
        {
          key: "activa_valor",
          sortable: true,
          class: "text-center",
          label: "Activa"
        },
        {
          label: "",
          key: "actions",
          sortable: false
        }
      ]
    };
  },
  created() {
    this.getRegistros();
    this.getEmpresas();
  },
  methods: {
    async getEmpresas() {
      try {
        // eslint-disable-next-line no-undef
        let { data } = await axios.get("/api/catalogos/empresas-list");
        this.empresas = data.data;
        //Unshift Agrega el elemento en el indice 0
        this.empresas.unshift({ id: null, nombre: "Ver todas" });
      } catch (error) {
        console.log(error);
      }
    },
    async getRegistros() {
      this.isLoading = true;
      try {
        // eslint-disable-next-line no-undef
        let res = await axios.post("/api/catalogos/cuentascks", {
          perPage: this.perPage,
          currentPage: this.currentPage,
          cuenta: this.cuenta,
          formato: this.formato,
          activa: this.activa,
          empresa_id: this.empresa_id,

        });
        this.items = [];
        this.items = res.data.data;
        this.totalRows = res.data.total;
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
